import theme, { Colors } from '@qnpm/q-theme';
import { getStyles, BorderStyle } from './style';
import * as Constants from './constant';
const { responsive: { screen, scale } } = theme;
const { scenes: { selectColors } } = Colors;
export function changeStringToNumber(value) {
    if (typeof value === 'string') {
        return parseFloat(value);
    }
    return value || 0;
}
/**
 * 获取组件的margin相关属性、宽度、高度
 * @param style 组件样式属性
 */
function getWrapperStyle(style) {
    const { marginTop, marginRight, marginBottom, marginLeft, marginHorizontal, marginVertical, width = '100%' } = style;
    return {
        marginTop,
        marginRight,
        marginBottom,
        marginLeft,
        marginHorizontal,
        marginVertical,
        width
    };
}
/**
 * 获取每个选项的文本wrapper样式
 * @param props 组件属性
 */
function getTextWrapperStyle(props, componentWidth) {
    const { type = 'base', lableRadius = 4, itemHeight, numberOfLists = 2, needScale = false } = props;
    // 是否是标签类型
    const isLabel = type === 'label';
    // 标签类型下，每个标签的圆角
    const radiusStyle = isLabel
        ? { borderRadius: changeStringToNumber(lableRadius) }
        : {};
    // 单个item的默认高度
    const defaultItemHeight = scale(Constants.kDefaultItemHeight[type], needScale);
    // 单个item的最终高度
    const height = typeof itemHeight === 'undefined'
        ? defaultItemHeight
        : changeStringToNumber(itemHeight);
    const scaledMargin = scale(Constants.kLabelItemMargin, needScale);
    // 标签类型下，每个标签的宽度
    let labelWidth = (componentWidth -
        scale(Constants.kLableWrapperPadding, needScale) * 2 -
        numberOfLists * 2 * scaledMargin) /
        numberOfLists;
    labelWidth = Math.floor(labelWidth * 100) / 100;
    const itemWidthStyle = isLabel ? { width: labelWidth } : {};
    const scaledHeight = scale(height, needScale);
    // 基础类型下只用高度
    return isLabel
        ? Object.assign(Object.assign(Object.assign({}, radiusStyle), itemWidthStyle), { height: scaledHeight, marginHorizontal: scaledMargin, marginTop: scaledMargin * 2, paddingVertical: 5 }) : { height: scaledHeight };
}
/**
 * 文本样式
 * @param props 组件属性
 */
function getTextStyle(props) {
    const { type = 'base', fontSize = Constants.kDefaultFontSize[type], needScale = false } = props;
    const { text } = getStyles(needScale)[type];
    let scaledFontSize = scale(changeStringToNumber(fontSize), needScale);
    return {
        normal: Object.assign(Object.assign({}, text.normal), { fontSize: scaledFontSize }),
        selected: Object.assign(Object.assign({}, text.selected), { fontSize: scaledFontSize }),
        disable: Object.assign(Object.assign({}, text.disable), { fontSize: scaledFontSize })
    };
}
/**
 *  图标icon样式
 * @param props 组件属性
 */
function getIconStyle(props) {
    const { type = 'base', iconSize = 20, needScale = false } = props;
    const { icon } = getStyles(needScale)[type];
    let scaledFontSize = scale(changeStringToNumber(iconSize), needScale);
    return Object.assign(Object.assign({}, icon), { fontSize: scaledFontSize });
}
/**
 * 解析组件需要的样式
 * @param props 组件属性
 * @param componentWidth 组件宽度
 */
export function getComponentStyles(props, componentWidth) {
    const { type = 'base', customStyle = {}, needScale = false } = props;
    const { component, wrapper, textWrapper, line } = getStyles(needScale)[type];
    const componentStyle = getWrapperStyle(customStyle);
    return {
        component: Object.assign(Object.assign({}, component), componentStyle),
        wrapper: Object.assign({}, wrapper),
        textWrapper: Object.assign(Object.assign({}, textWrapper), getTextWrapperStyle(props, componentWidth)),
        text: Object.assign({}, getTextStyle(props)),
        icon: Object.assign({}, getIconStyle(props)),
        line: Object.assign({}, line)
    };
}
/**
 * 获取标签类型下，被选中item背景色
 * @param props 组件属性
 * @param selected 是否选中
 */
export function getSelectBgColor(type, selected, labelType, disable) {
    const isLabel = type === 'label';
    const selectKey = selected ? 'selected' : 'normal';
    const borderStyle = isLabel && labelType === 'line' ? BorderStyle[selectKey] : {};
    if (disable) {
        return isLabel
            ? Object.assign({ backgroundColor: labelType === 'side'
                    ? selectColors.silverBackgroud
                    : selectColors.whiteBackground }, borderStyle) : Object.assign({ backgroundColor: selectColors.whiteBackground }, borderStyle);
    }
    return selected && isLabel
        ? Object.assign({ backgroundColor: selectColors.brandBackground }, borderStyle) : Object.assign({ backgroundColor: isLabel && labelType === 'side'
            ? selectColors.silverBackgroud
            : 'white' }, borderStyle);
}
